{
  "UnifiedNavigation": "Navegación en Experience Cloud",
  "adobeExperienceCloudNoOrgsSelect": "Seleccione otra cuenta de organización",
  "help": "Ayuda",
  "ok": "Aceptar",
  "profile": "Perfil",
  "searchButton": "Buscar",
  "sidenavMenuCloseTooltip": "Cerrar menú",
  "sidenavMenuLockTooltip": "Haga clic para bloquear el menú",
  "solutionSwitcher": "Cambiar a otra solución",
  "themeCoachMark": "Tema claro",
  "themeCoachMarkMessage": "Ahora, el encabezado de Experience Cloud admite los temas claro y oscuro. Haga clic en su avatar para cambiar de un tema a otro y elegir su preferido.",
  "toggleSideNav": "Alternar menú de navegación lateral"
}
